import ExpandLessIcon from "@mui/icons-material/ExpandLess";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import InfoIcon from "@mui/icons-material/Info";
import Card from "@mui/material/Card";
import CardActions from "@mui/material/CardActions";
import CardContent from "@mui/material/CardContent";
import IconButton from "@mui/material/IconButton";
import { useState } from "react";
import { useHistory } from "react-router-dom";
import { Counter } from "../Counter";

export function Movie({
  name,
  poster,
  summary,
  rating,
  id,
  deleteButton,
  editButton,
}) {
  const [show, setShow] = useState(true);
  const history = useHistory();

  // Conditional styling
  const styles = { display: show ? "block" : "none" };
  return (
    <Card className="movie-container">
      <img className="movie-poster" src={poster} alt={name} />
      <CardContent>
        <div className="movie-specs">
          <h3 className="movie-name">
            {name}

            <IconButton onClick={() => setShow(!show)} color="primary">
              {show ? <ExpandLessIcon /> : <ExpandMoreIcon />}
            </IconButton>
            <IconButton
              onClick={() => history.push(`/movies/${id}`)}
              color="primary"
            >
              <InfoIcon />
            </IconButton>
          </h3>
          <p className="movie-rating">⭐ {rating}</p>
        </div>

        {/* <button  style={{ marginBottom: "10px" }}>
        {show ? "Hide" : "Show"} description
      </button> */}
        {/* <p style={styles} className="movie-summary">
        {summary}
      </p> */}

        {/* Conditional rendering */}
        {show ? <p className="movie-summary">{summary}</p> : ""}
        <CardActions>
          <Counter />
          {editButton}
          {deleteButton}
        </CardActions>
      </CardContent>
    </Card>
  );
}

// Task
// Add movie to the movie list with a form - name, poster, rating, description

// C- create - Add movie - done
// R - movie details - done - style
// U - update - Edit movie - /movies/edit/:id
// D - delete movie - Delete movie

// Add form to different component & Route
// /movies/add
